<template>
  <page-container>
    <template v-slot:page-fixed-header>
      <span class="text-h5 font-weight-bold ml-3 full-width page-header">{{
        $t("statistics.hTimeAllocation")
      }}</span>
      <v-spacer></v-spacer>

      <v-tooltip
        bottom
        v-if="$security.checkUserAccess('ViewMeetingStatistics')"
      >
        <template v-slot:activator="{ on, attrs }">
          <a-btn
            v-if="$security.checkUserAccess('ViewMeetingStatistics')"
            v-bind="attrs"
            v-on="on"
            class="mr-2"
            color="primaryDark"
            @click="$router.push({ path: '/statistics&analysis' })"
          >
            {{ $t("Back") }}
          </a-btn>
        </template>
        <span>{{ $t("Back") }}</span>
      </v-tooltip>
      <v-tooltip
        bottom
        v-if="$security.checkUserAccess('ViewMeetingStatistics')"
      >
        <template v-slot:activator="{ on, attrs }">
          <a-btn
            v-if="$security.checkUserAccess('ViewMeetingStatistics')"
            v-bind="attrs"
            v-on="on"
            class="mr-2"
            color="primaryDark"
            @click="openDialog"
          >
            {{ $t("lblFilter") }}
          </a-btn>
        </template>
        <span>{{ $t("lblFilter") }}</span>
      </v-tooltip>
    </template>
    <template v-slot:page-content>
      <v-card tile flat style="width: 100%" color="Neutral">
        <v-card-text style="padding: 0 0 16px 12px">
          <v-row no-gutters>
            <v-col cols="12" sm="12" md="6">
              <v-skeleton-loader
                class="pie-chart-skeleton"
                v-if="isSkeletonLoading"
                type="card-heading, image"
              ></v-skeleton-loader>
              <topic-count-chart
                v-else
                :key="render"
                :chartData="chartData"
                :title="$t('statistics.titleScheduleTimeAgendaCat')"
              />
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-skeleton-loader
                class="pie-chart-skeleton"
                v-if="isSkeletonLoading"
                type="card-heading, image"
              ></v-skeleton-loader>
              <topic-count-chart
                v-else
                :key="render"
                :chartData="chartData"
                :isActualTimeChart="true"
                :title="$t('statistics.titleActualTimeAgendaCat')"
              />
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-skeleton-loader
                class="pie-chart-skeleton"
                v-if="isSkeletonLoading"
                type="card-heading, image"
              ></v-skeleton-loader>
              <topic-count-chart
                v-else
                :key="render"
                :chartData="chartData"
                props="topicCategory"
                :title="$t('statistics.titleScheduleTimeTopicCat')"
              />
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-skeleton-loader
                class="pie-chart-skeleton"
                v-if="isSkeletonLoading"
                type="card-heading, image"
              ></v-skeleton-loader>
              <topic-count-chart
                v-else
                :key="render"
                :chartData="chartData"
                props="topicCategory"
                :isActualTimeChart="true"
                :title="$t('statistics.titleActualTimeTopicCat')"
              />
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <v-skeleton-loader
                class="bar-chart-skeleton"
                v-if="isSkeletonLoading"
                type="card-heading, image"
              ></v-skeleton-loader>
              <actual-vs-schedule-time-chart
                v-else
                :key="render"
                :chartData="chartData"
                :title="$t('statistics.titleScheduleVsActualTimeAgendaCat')"
              />
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <v-skeleton-loader
                class="bar-chart-skeleton"
                v-if="isSkeletonLoading"
                type="card-heading, image"
              ></v-skeleton-loader>
              <actual-vs-schedule-time-chart
                v-else
                :key="render"
                :chartData="chartData"
                props="topicCategory"
                :title="$t('statistics.titleScheduleVsActualTimeTopicCat')"
              />
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12" sm="12" md="12">
              <v-skeleton-loader
                class="bar-chart-skeleton"
                v-if="isSkeletonLoading"
                type="card-heading, image"
              ></v-skeleton-loader>
              <timer-recorded-data v-else :key="render" :filteredMeetingList="filteredMeetingList"></timer-recorded-data>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <time-allocation-filter
        v-if="isTimeAllocationOpen"
        v-model="isTimeAllocationOpen"
        @timeAllocationPayload="getFilterInput"
        :item="obj"
      ></time-allocation-filter>
    </template>
  </page-container>
</template>

<script>
import TimeAllocationFilter from "@/components/statistics/TimeAllocationFilter.vue";
import FilterDialog from "@/components/statistics/FilterDialog.vue";
import UserCard from "@/components/statistics/UserCard.vue";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { formatDate } from "@/utils/util";
import ActualVsScheduleTimeChart from "@/components/agenda/widget/charts/ActualVsScheduleTimeChart.vue";
import TopicCountChart from "@/components/agenda/widget/charts/TopicCountChart.vue";
import MeetingFilter from "@/components/agenda/MeetingFilter.vue";
import TimerRecordedData from "./TimerRecordedData.vue";
import SignalRMixin from "@/mixin/SignalRMixin";

export default {
  name: "TimeAllocation",
  mixins: [SignalRMixin],
  components: {
    UserCard,
    FilterDialog,
    ActualVsScheduleTimeChart,
    TopicCountChart,
    MeetingFilter,
    TimeAllocationFilter,
    TimerRecordedData,
  },
  data() {
    return {
      filteredMeetingList: [],
      timeAllocationFilterInputs: null,
      isTimeAllocationOpen: false,
      isSkeletonLoading: false,
      listOfMeetingTypes: [],
      selectedMeetingTypes: [],
      chartData: [],
      meetingsListData: [],
      topicCategories: [],
      renderPDF: null,
      filteredUsers: [],
      render: 0,
      meetingTypeObj: {},
      obj: {
        id: "time_allocation",
        title: this.$t("statistics.hTimeAllocation"),
      },
    };
  },
  computed: {
    ...gettersMap(),
    ...mapState({
      agendaList: (state) => state.agenda.agendaList,
      meetingsList: (state) => state.meeting.customMeetingsList,
    }),
    selectedLang() {
      return this.$i18n.locale;
    },
    dateFormat() {
      return this.selectedLang !== "ja" ? "dd-MM-yyyy" : "yyyy-MM-dd";
    },
    loaderText() {
      return this.$t("LoaderText");
    },
    selectedTenant() {
      return sessionStorage.getItem("tenantId");
    },
  },
  async created() {
    this.isSkeletonLoading = true;
  },
  async mounted() {
    await this.getAgendaListApi();
    await this.getTenantConfigList();
    this.topicCategories = await this.tenantSettingTypes("topiccategory").sort(
      (a, b) => a.order - b.order
    );

    let timeAllocationFilterInputs = sessionStorage.getItem(
      "timeAllocationFilterInputs"
    );
    
    if (timeAllocationFilterInputs) {
      this.timeAllocationFilterInputs = JSON.parse(timeAllocationFilterInputs);
      this.selectedMeetingTypes = this.timeAllocationFilterInputs?.meeting_type.map((i) => i.id);
      if (
        !this.meetingsList.length &&
        Object.keys(this.timeAllocationFilterInputs).length
      ) {
        await this.getCustomMeetingList(this.timeAllocationFilterInputs)
          .then((response) => {})
          .catch((error) => {
            console.error(error);
          });
      }
    } else {
      this.timeAllocationFilterInputs = {};
    }
    await this.getMeetingsList();
    this.signalRInit(`meeting_${this.selectedTenant}`);
    this.isSkeletonLoading = false;
  },
  methods: {
    ...mapActions({
      getAgendaListApi: "agenda/getAgendaList",
      getTenantConfigList: "tenant/getTenantConfigList",
      getCustomMeetingList: "meeting/getCustomMeetingList",
    }),
    formatDate,
    signalRInit,
    getMeetingsList() {
      this.isSkeletonLoading = true;
      let list;
      if (this.selectedMeetingTypes.length) {
        list = this.meetingsList.filter((i) =>
          this.selectedMeetingTypes.includes(i.meetingTypeId)
        );
      } else {
        list = this.meetingsList;
      }
      this.filteredMeetingList = list;
      const data = list
        .filter((f) => f.topics.length)
        .map((type) => {
          return {
            meetingName: type.meetingName,
            meetingType: type.meetingType,
            topics: type.topics,
          };
        });

      const arrChartData = [];
      data.forEach((meetingData) => {
        meetingData.topics.forEach((topic) => {
          const agenda = this.agendaList.find((a) => a.id === topic.agendaId);
          const topicCategoryData = this.topicCategories.find(
            (tc) => tc.id === topic.topicCategory
          );
          if (agenda && topicCategoryData) {
            const chartObj = {
              meetingName: meetingData.meetingName,
              meetingType: meetingData.meetingType,
              agendaName: agenda.agendaName,
              agendaCategory: agenda.category,
              topicName: topic.topicName,
              topicCategory: topicCategoryData.name,
              scheduleTime: topic.timeInMinutes
                ? Math.round(Number(topic.timeInMinutes))
                : 0,
              actualTime: (topic?.starttime && topic?.endtime && this.getMinutes(topic.starttime, topic.endtime))
                ? Math.round(this.getMinutes(topic.starttime, topic.endtime) - (topic?.totalPauseTime || 0 ) / 60000) 
                : 0,
             };
            arrChartData.push(chartObj);
          }
        });
      });

      this.chartData = arrChartData;
      this.meetingsListData = [...arrChartData];
      this.isSkeletonLoading = false;
    },
    getMinutes(startDate, endDate) {
      let start = new Date(startDate);
      let end = new Date(endDate);
      let milliSec = Math.abs(end - start);
      return Number(Math.floor(milliSec / 60000)).toFixed(2);
    },
    async getFilterInput(obj) {
      this.timeAllocationFilterInputs = obj;
      this.selectedMeetingTypes =
        this.timeAllocationFilterInputs?.meeting_type.map((i) => i.id);
      await this.getMeetingsList();
      this.render++;
    },
    openDialog() {
      this.isTimeAllocationOpen = true;
    },
  },
};

function signalRInit(target) {
  this.signalConnection.on(target, async (message) => {
    if (message) {
      try {
        await this.getCustomMeetingList(this.timeAllocationFilterInputs);
        await this.getMeetingsList();
      } catch (error) {
        console.log(error, "API error");
      }
    }
  });
  if (this.signalConnection.connectionState.toLowerCase() === "disconnected") {
    this.signalConnection.start().catch();
  }
}

function gettersMap() {
  return mapGetters({
    tenantSettingTypes: "tenant/tenantSettingTypes",
  });
}
</script>

<style scoped>
.pie-chart-skeleton,
.bar-chart-skeleton {
  border: thin solid rgba(0, 0, 0, 0.12);
}
</style>